var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-interactive"
  }, [_c('top', {
    attrs: {
      "iskf": true,
      "isOrder": true
    },
    on: {
      "intoIm": _vm.goChat
    }
  }), _vm._v(" "), (_vm.carouselList && _vm.carouselList.length) ? _c('div', {
    staticClass: "top-carousel"
  }, [_c('el-carousel', {
    attrs: {
      "height": "200px",
      "indicator-position": "none"
    }
  }, _vm._l((_vm.carouselList), function(item, index) {
    return _c('el-carousel-item', {
      key: item,
      nativeOn: {
        "click": function($event) {
          _vm.swipeClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ai-left-content"
  }, [_c('div', {
    staticClass: "hot-question"
  }, [_c('div', {
    staticClass: "hot-top-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.total > _vm.hotParams.size) ? _c('div', {
    staticClass: "toggle-content",
    on: {
      "click": _vm.toggles
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-Toggle",
    style: ({
      color: _vm.boxBodyColor
    })
  }), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.boxBodyColor
    })
  }, [_vm._v("换一换")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hot-btm-content"
  }, _vm._l((_vm.hotList), function(item, i) {
    return _c('div', {
      key: item.id,
      staticClass: "hot-item-content"
    }, [_c('div', {
      staticClass: "hot-item",
      on: {
        "click": function($event) {
          _vm.hotClick(item)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(1, true)])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ai-right-content"
  }, [_c('div', {
    staticClass: "question-type"
  }, [_c('div', {
    staticClass: "question-type-content"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v("全部问题类型")]), _vm._v(" "), _c('div', {
    staticClass: "type-btm-content"
  }, _vm._l((_vm.questionType), function(item, i) {
    return _c('div', {
      key: item.id,
      staticClass: "type-item",
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.questionName))]), _c('i', {
      staticClass: "el-icon-arrow-right"
    })])
  }))])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-title"
  }, [_c('span', [_vm._v("热点问题")]), _c('img', {
    attrs: {
      "src": require("../../assets/hot-icon.png"),
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-btm-right"
  }, [_c('span', [_vm._v("查看详情")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/receipt-item-right.png"),
      "alt": ""
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-191ca598","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/aiInteractive.vue
// module id = Ntul
// module chunks = 1